<header class="header-page">
  <section class="col-7 px-0">
    <h1 class="header__page__content__title">
      Histórico de Declarações
    </h1>
  </section>
  <section class="col-5 float-right px-sm-0">
    <button type="submit" class="btn btn-outline-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 float-right"
      [routerLink]="['/solicitar-declaracao']" [queryParams]="{ productId: this.formData.value.productId}">
      Voltar
    </button>
  </section>
</header>
<ng-template #showLoading>
  <spinner [show]="true"></spinner>
</ng-template>
<main class="col-sm-12 col-xl-12 main__content" *ngIf="!loading; else showLoading">
  <section class="content__header__page">
  </section>
  <section>
    <form [formGroup]="formData" class="content__form px-0">
      <section class="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
        <div class="col-xl-2 px-1">
          <label class="labelFiltro">Produto</label>
          <ng-select [items]="productsList" bindLabel="description" bindValue="id" [searchable]="false"
            formControlName="productId" placeholder="Todos" notFoundText="Não há items" loadingText="Carregando..."
            (change)="getModels()">
          </ng-select>
        </div>
        <div class="col-xl-2 px-1">
          <label class="labelFiltro">Modelo</label>
          <ng-select [items]="modelsList" bindLabel="description" bindValue="id" [searchable]="false"
            formControlName="typeId" placeholder="Todos" notFoundText="Não há items" loadingText="Carregando...">
          </ng-select>
        </div>
        <div class="col-xl-2 px-1">
          <label class="labelFiltro">Protocolo</label>
          <input class="form-control input-form" formControlName="protocol" maxlength="20" placeholder="Ex: 706952394"
            type="number" step="1" onkeydown="if(event.key==='.'){event.preventDefault();}"
            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
        </div>
      </section>
    </form>
  </section>
  <section class="mt-2 col-12 p-0">
    <button type="submit" class="btn btn-primary col-xl-2 col-lg-3 col-md-4 col-sm-12" (click)="load()">
      <div class="spinner-border" role="status" *ngIf="loading; else showSpan" [@fadeInOut]>
        <span class="sr-only">Pesquisando</span>
      </div>
      <ng-template #showSpan>
        <span>Pesquisar</span>
      </ng-template>
    </button>
  </section>
  <section class="content__main" *ngIf="listaDeclaracoes && listaDeclaracoes.length > 0">
    <div class="content__header">
      <h3>
        Minhas declarações
      </h3>
      <filtro-dados [pageItens]="5" [totalItens]="listaDeclaracoes.totalFiltered"
        (changeQuantidade)="onChangeQuantidadeItens($event)" *ngIf="listaDeclaracoes && listaDeclaracoes.length > 0">
      </filtro-dados>
    </div>
    <div class="d-flex content__header__table">
      <div class="col-xl-4">Protocolo</div>
      <div class="col-xl-4">Data e hora da solicitação</div>
      <div class="col-xl-3">Modelo da declaração</div>
      <div class="col-xl-1 text-center">Ações</div>
    </div>
    <div class="table__card" *ngFor="let declaracao of listaDeclaracoes;let i = index">
      <div class="col-xl-4">{{declaracao.protocol}}</div>
      <div class="col-xl-4">{{(declaracao.date | date:'dd/MM/yyyy') || ' - '}}</div>
      <div class="col-xl-3">{{declaracao.model}}</div>
      <div class="col-xl-1 text-center">
        <fa-icon class="fa-icon" [icon]="faDownload" (click)="download(declaracao, i)"
          *ngIf="idCurrentDownload != i"></fa-icon>
        <span class="spinner" *ngIf="idCurrentDownload == i && loadingDownload">
        </span>
      </div>
    </div>
  </section>
  <section class="col-12 footer__content">
    <paginacao [currentPage]="1" [collectionSize]="listaDeclaracoes?.totalFiltered" [pageSize]="filter.ItemsPerPage"
      (changeNumber)="onChangePagination($event)">
    </paginacao>
  </section>
</main>